export default (applicationName) => {
  let pid;
  switch (applicationName) {
    // 各种节假日活动
    case 'activities':
      pid = 'ay1313ae4i@82d30f62aafadd7';
      break;
    // 活动中心
    case 'activity-center':
      pid = 'ay1313ae4i@3a5c1eda67fd1b2';
      break;
    // 各种落地页
    case 'landing-page':
      pid = 'ay1313ae4i@7e706197f532417';
      break;
    // 其他（MXC内部正式使用）
    case 'miaocode':
      pid = 'ay1313ae4i@43548a451f67939';
      break;
    // 作品类
    case 'uo-badyworks':
      pid = 'ay1313ae4i@1f50b32c9d7ab92';
      break;
    // 报告类
    case 'report':
      pid = 'ay1313ae4i@51c18cf66ffa407';
      break;
    // 宣传/介绍/引导/说明类
    case 'guide-page':
      pid = 'ay1313ae4i@0b86d2e413d83c7';
      break;
    // 考试
    case 'exam':
      pid = 'ay1313ae4i@9b162ca98d8e500';
      break;
  }
  const BrowserLogger = require('alife-logger');
  const __bl = BrowserLogger.singleton({
    pid: pid,
    appType: 'web',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    enableLinkTrace: true,
    behavior: true,
    enableConsole: true,
    environment: process.env.NODE_ENV === 'production' ? 'prod' : 'daily',
    errorHandler: (err, vm, info) => {
      arms.error(err, { filename: `${vm.$vnode.tag}, ${info}` });
    },
  });
}


// WEBPACK FOOTER //
// ./src/utils/BrowserLogger.js